/**
 * convert the formdata to a nested object
 **/
const convertFormData = function (formData) {
  const result = {};
  let formDataObject = Object.assign(
    ...Array.from(formData.entries(), ([x, y]) => ({ [x]: y })),
  );

  Object.keys(formDataObject).forEach((key) => {
    const parts = key.split(/[\[\]]+/).filter(Boolean);
    let current = result;
    while (parts.length > 1) {
      const part = parts.shift();
      if (!current[part] && typeof current !== 'undefined') {
        current[part] = isNaN(parts[0]) ? {} : [];
      }
      current = current[part];
    }
    current[parts[0]] = formDataObject[key];
  });

  return result;
};

export default convertFormData;
